import { ClipboardList, Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { Textarea } from '@/components/ui/textarea'
import { DetailSection } from './DetailSection'

export interface InvestigationDescriptionCardProps {
  draft: string
  onDraftChange: (value: string) => void
  saving: boolean
  isDirty: boolean
  disabled: boolean
  onSave: () => void
  onReset: () => void
}

export function InvestigationDescriptionCard({
  draft,
  onDraftChange,
  saving,
  isDirty,
  disabled,
  onSave,
  onReset,
}: InvestigationDescriptionCardProps) {
  const { t } = useTranslation()
  return (
    <DetailSection
      icon={<ClipboardList className="size-4" />}
      title={t('investigations.detail.description.title')}
      hint={t('investigations.detail.description.hint')}
    >
      <Textarea
        className="min-h-[120px] resize-y"
        placeholder={t('investigations.detail.description.placeholder')}
        value={draft}
        onChange={e => onDraftChange(e.target.value)}
        disabled={disabled || saving}
      />
      <div className="mt-3 flex items-center justify-between gap-2">
        <span className="text-2xs text-muted-foreground">
          {disabled
            ? t('investigations.detail.description.readOnly')
            : isDirty
              ? t('investigations.detail.description.unsaved')
              : t('investigations.detail.description.saved')}
        </span>
        <div className="flex gap-2">
          <Button variant="ghost" size="sm" onClick={onReset} disabled={!isDirty || saving}>
            {t('common.cancel')}
          </Button>
          <Button size="sm" onClick={onSave} disabled={!isDirty || saving || disabled}>
            {saving && <Loader2 className="size-3.5 animate-spin" />}
            {t('common.save')}
          </Button>
        </div>
      </div>
    </DetailSection>
  )
}
